import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import { useBranding } from 'contexts/BrandingContext';
import zoidesqLogo from 'assets/images/zoidesq.png';

// ==============================|| LOGO ICON ||============================== //

export default function MultiTenantLogoIcon() {
  const { companyName, logo, brandColor } = useBranding();
  const role = localStorage.getItem('role');
  const isCompanyAdmin = role && role !== 'SUPER_ADMIN';

  // Company admin — show company logo or initial
  if (isCompanyAdmin && (logo || companyName)) {
    return logo ? (
      <Avatar
        src={logo}
        alt={companyName}
        variant="rounded"
        sx={{ width: 32, height: 32, borderRadius: 1.5 }}
      />
    ) : (
      <Box sx={{
        width: 32, height: 32, borderRadius: 1.5,
        bgcolor: brandColor || '#0D9488',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.875rem' }}>
          {companyName?.charAt(0)?.toUpperCase() || 'Z'}
        </Typography>
      </Box>
    );
  }

  // Default ZoidesQ icon
  return <Box component="img" src={zoidesqLogo} alt="ZoidesQ" sx={{ width: 34, height: 34, objectFit: 'contain' }} />;
}
